function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".campaigns_svg__st0{fill:none;stroke:#000;stroke-width:inherit;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "campaigns_svg__st0",
  d: "M5.438 8.905l-.289-.879m5.826-2.707l-.808-2.461M4.384 4.015L1.037 5.097.3 5.978 1.127 8.5l1.118.281 3.912-1.012z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "campaigns_svg__st0",
  d: "M2.807 8.636l.947 2.872.571.198 1.384-.447.344-.494-.615-1.86.577-.186.276-.54-.134-.41c.415.007 2.304-.269 5.55-.22l-.732-2.23.636-.623-.56-1.706-.884-.132L9.328.3 4.384 4.015"
});

function SvgCampaigns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "campaigns_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 12.006 12.006",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCampaigns;